import {
  ManageOwnershipDialog,
  entityToOwnershipEntity,
  useManageOwnershipDialog,
} from '@internal/backstage-plugin-common-library-react';
import React from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import {
  Box,
  Button,
  IconButton,
  Tooltip,
  makeStyles,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const REPOSITORY_OWNERSHIP_DOCS_URL =
  '/docs/default/component/frontstage/ownership/repository/';

const useStyles = makeStyles(() => ({
  button: {
    textTransform: 'none',
  },
}));

export const RepositoryManageOwnership = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const { dialogOpen, openDialog, closeDialog, handleSuccess } =
    useManageOwnershipDialog();

  return (
    <>
      <Box display="flex" alignItems="center" gridGap={8}>
        <Button
          className={classes.button}
          color="primary"
          variant="outlined"
          onClick={openDialog}
        >
          Manage Ownership
        </Button>
        <Tooltip title="Open repository ownership documentation">
          <IconButton
            component="a"
            href={REPOSITORY_OWNERSHIP_DOCS_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open repository ownership documentation"
            size="small"
          >
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <ManageOwnershipDialog
        open={dialogOpen}
        entities={[entityToOwnershipEntity(entity)]}
        onClose={closeDialog}
        onSuccess={handleSuccess}
      />
    </>
  );
};
